import { SkeletonLoader, getTestAttributes, sizing } from '@chillibean/component-library';
import styled from 'styled-components';

export function SubjectRequirementsContainerLoading() {
  return (
    <SkeletonLoaderContainer {...getTestAttributes('subject-requirement-loader')}>
      <SkeletonLoader
        key={0}
        height={66}
        preserveAspectRatio="none"
        style={{ borderRadius: sizing.xsmall, width: '100%' }}
        width={100}
      >
        <rect height={40} width="100%" />
      </SkeletonLoader>
      {[1, 2].map((num) => (
        <SkeletonLoader
          key={num}
          height={66}
          preserveAspectRatio="none"
          style={{ borderRadius: sizing.xsmall, width: '100%' }}
          width={100}
        >
          <rect height={32} width="100%" />
        </SkeletonLoader>
      ))}
      <SkeletonLoader
        key={3}
        height={66}
        preserveAspectRatio="none"
        style={{ borderRadius: sizing.xsmall, width: '100%' }}
        width={10}
      >
        <rect height={40} width="10%" />
      </SkeletonLoader>
    </SkeletonLoaderContainer>
  );
}

const SkeletonLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default SubjectRequirementsContainerLoading;
